import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { GET_ALL_WATER_TRUCKS_REQUEST_BY_CONCILIATION_ID } from '../../../../graphql/Catalog/WaterTruckRequest/waterTruckRequest'
import { toastSweetAlert } from '../../../Helpers/ToastSweetAlert'
import LayoutTable from '../../../Global/LayoutTable'
import { useQuery } from '@apollo/client'
import Box from '../../../Global/Box'
import moment from 'moment'
import ContentHeader from '../../../Layout/ContentHeader'
import ProgressBarStatusReport from '../../../Global/ProgressBarStatusReport'

const ConciliationNew = () => {
  const { id: _id, show } = useParams()

  //----------- Hooks --------
  const [dataTable, setDataTable] = useState({
    data: [],
    total: 0,
  })
  const [pagePagination, setPagePagination] = useState({
    searchQuery: null,
    limit: 10,
    offset: 0,
    conciliation_id: parseInt(_id ? _id : 0),
  })

  const { data, loading, error, refetch } = useQuery(
    GET_ALL_WATER_TRUCKS_REQUEST_BY_CONCILIATION_ID,
    {
      variables: {
        conciliationId: pagePagination.conciliation_id,
        limit: pagePagination.limit,
        offset: pagePagination.offset,
        searchQuery: pagePagination.searchQuery,
      },
      fetchPolicy: 'no-cache',
    }
  )

  //----------- Use Effects
  useEffect(() => {
    if (!loading) {
      if (error) return toastSweetAlert({ type: 'error', text: error.message })

      const { getAllWaterTruckRequestByConciliationId } = data

      const list = getAllWaterTruckRequestByConciliationId.rows.map((item) => ({
        id: item.id,
        folio: item.folio,
        volumen: item.volume,
        extemporaneo: item.is_extemporaneous ? 'Si' : 'No',
        'Fecha de creación': item?.createdAt
          ? moment(item.createdAt).format('DD-MM-YYYY')
          : 'Sin fecha',
        'Fecha de finalización': item?.completed_at
          ? moment(item.completed_at).format('DD-MM-YYYY')
          : 'Sin fecha',
        // prioridad: item.priority,
        tipo: item.type_delivery,
        'Placa Camion':
          item?.RoutesOfWaterTruckRequest?.RouteToTrucks?.plate_number,
        // provedor: item.ProviderOfWaterTruckRequest?.card_name,
        estatus: (
          <>
            <ProgressBarStatusReport
              statusReport={item?.StatusOfWaterTruckRequest}
            />
          </>
        ),
      }))

      setDataTable({
        data: list,
        total: getAllWaterTruckRequestByConciliationId.count,
      })
    }
  }, [data, loading, error])

  return (
    <>
      <ContentHeader
        title="Conciliación"
        windowTitle="Conciliación"
        breadcrumb=""
      />

      <div className="col-12 pt-4">
        <div className="d-flex justify-content-between align-items-center flex-wrap">
          <div>
            <Link
              className="btn btn-migrates-white mb-3"
              to={`/conciliation`}
            >
              <i className="fas fa-long-arrow-alt-left" /> Atrás
            </Link>
            <h1 className="header-title">Pipas de conciliación</h1>
          </div>
        </div>
      </div>
      <LayoutTable
        hideId
        hideActions
        hideAddNew
        exportImportButton={false}
        title="Pipas de la conciliación"
        data={dataTable.data}
        totalCount={dataTable.total}
        loadingData={loading}
        pagePagination={pagePagination}
        setPagePagination={setPagePagination}
        refetchFunctionQueries={refetch}
        requery={GET_ALL_WATER_TRUCKS_REQUEST_BY_CONCILIATION_ID}
        hideFilterBar
        // FilterBarPlaceholder="Buscar por folio"
      />
    </>
  )
}

export default ConciliationNew
